// Mock data for Mael Perrichet Portfolio

export const personalInfo = {
  name: "MAEL PERRICHET",
  title: "International Management Student",
  tagline: "Passionate about International Human Resources & Talent Development Across Cultures",
  email: "m.perrichet@audencia.com",
  phone: "+33 6 16 12 91 98",
  linkedin: "www.linkedin.com/in/mael-perrichet/",
  location: "Nantes, France",
  bio: "Third-year International Management student at Audencia Business School, pursuing an English-language track. Passionate about people, organizational dynamics, and the human side of international business. My journey has enabled me to develop a strong understanding of cross-cultural environments, talent management, and HR practices in a global context. Beyond my studies, I am a huge basketball fan and passionate about fashion, two worlds that nurture my sense of teamwork, creativity, and style.",
  about: "I am seeking a 6-month internship in International Human Resources starting January 2027. My background combines hands-on experience in recruitment, personnel administration, and organizational support with strong academic training in international business management. I thrive in multicultural environments and am eager to contribute to HR projects that connect people across cultures and drive organizational growth."
};

export const experience = [
  {
    id: 0,
    company: "CRIT",
    position: "Recruitment Assistant – Aerospace, Logistics & Services Sectors",
    location: "Rezé, France",
    period: "January 2026 – May 2026",
    description: "Supported end-to-end recruitment operations across three business sectors within a major French staffing agency, from candidate sourcing to post-placement follow-up.",
    responsibilities: [
      "Sourcing and identifying targeted candidates through job boards and internal databases.",
      "Drafting and posting attractive job listings tailored to the specific needs of the Nantes job market.",
      "Conducting telephone pre-qualification interviews and in-person recruitment interviews.",
      "Handling administrative tasks related to personnel, including drafting contracts and scheduling medical exams.",
      "Managing the operational flow of job orders and forwarding qualified candidates to companies.",
      "Monitoring onboarding and conducting satisfaction surveys with clients.",
      "Expanding the candidate pool through active participation in local job fairs and events."
    ]
  },
  {
    id: 1,
    company: "TSM Garage",
    position: "Logistics & Administration Assistant",
    location: "Pouzauges, France",
    period: "July 2025 – August 2025",
    description: "Managed spare parts inventory and optimized billing processes for refrigerated trailers and semi-trailers.",
    responsibilities: [
      "Received and recorded spare parts orders using internal software and Microsoft Excel",
      "Assigned product codes and tracked inventory entries via management system",
      "Contributed to implementation and optimization of billing process on internal software",
      "Organized and archived administrative documents according to established procedures",
      "Monitored garage equipment and consumables inventory (supply chain)",
      "Controlled and recorded quantities of fuel and AdBlue received for analytical tracking"
    ]
  },
  {
    id: 2,
    company: "NACCON GmbH",
    position: "Executive Assistant",
    location: "Kirchberg an der Jagst, Germany",
    period: "January 2024 – February 2024",
    description: "Provided direct support to CEO and senior consultant on strategic greenhouse gas accounting project.",
    responsibilities: [
      "Supported CEO and senior consultant on strategic greenhouse gas accounting project",
      "Developed and structured Excel calculation models for emissions tracking and analysis",
      "Conducted technical and regulatory literature review in German to inform decision-making",
      "Contributed to project coordination and deliverable tracking for efficient mission management"
    ]
  },
  {
    id: 3,
    company: "ICI (Initiatives Conseil International)",
    position: "Accounting Assistant",
    location: "Ouagadougou, Burkina Faso",
    period: "March 2020",
    description: "Supported accounting team with financial operations and regulatory compliance.",
    responsibilities: [
      "Assisted accounting team in processing and recording financial operations",
      "Participated in organization and tracking of accounting documents for Burkinabe regulatory compliance"
    ]
  },
  {
    id: 4,
    company: "Cheval Mandingue",
    position: "Budget Management & Team Management Assistant",
    location: "Ouagadougou, Burkina Faso",
    period: "July 2019 – August 2019",
    description: "Supported club accounting and administrative management.",
    responsibilities: [
      "Supported club accounting operations",
      "Participated in administrative management",
      "Assisted in team mission coordination and organization"
    ]
  }
];

export const education = [
  {
    id: 1,
    degree: "Bachelor in International Management",
    institution: "Audencia Business School",
    location: "Nantes, France",
    period: "September 2023 – June 2027",
    description: "English-language track focused on international business strategy and global management.",
    courses: [
      "Financial Performance Management",
      "Business Strategy",
      "Data Analysis and Business Intelligence",
      "Project Management",
      "Responsible Consumer Behavior",
      "Human Resources Management",
      "Commercial Law"
    ],
    secondaryCourses: [
      "German (Second Language)",
      "Positive Communication in Professional Settings",
      "Programming"
    ]
  },
  {
    id: 2,
    degree: "French Baccalauréat",
    institution: "Lycée Français St-Exupéry",
    location: "Ouagadougou, Burkina Faso",
    period: "Graduated June 2023",
    description: "Graduated with Honors (Mention Bien)",
    specializations: [
      "Economics and Social Sciences (SES)",
      "Foreign Languages, Literatures and Cultures (LLCE)",
      "Latin"
    ],
    activities: [
      "Basketball",
      "Winner of 'Peace in All Languages' Project"
    ]
  }
];

export const skills = {
  technical: [
    { name: "Microsoft Excel", level: 90 },
    { name: "Office 365", level: 85 },
    { name: "Power BI", level: 75 },
    { name: "Confluence", level: 70 },
    { name: "Jira", level: 70 },
    { name: "HTML/CSS", level: 65 },
    { name: "Agile Methodology", level: 75 },
    { name: "Windows", level: 90 }
  ],
  expertise: [
    "International Management & Strategy",
    "Commerce & International Relations",
    "Finance & Accounting",
    "Data & Digital Tools",
    "Supply Chain & Logistics",
    "Project Coordination",
    "Human Resources",
    "Talent Acquisition",
    "Applicant Tracking Systems (ATS)"
  ]
};

export const languages = [
  { name: "French", level: "Native (C1)", proficiency: 100 },
  { name: "English", level: "Fluent (C1)", proficiency: 100 },
  { name: "German", level: "Professional (B2)", proficiency: 40 }
];

export const projects = [
  {
    id: 1,
    title: "Greenhouse Gas Accounting Model",
    category: "Strategic Consulting",
    description: "Developed comprehensive Excel-based calculation models for tracking and analyzing greenhouse gas emissions for NACCON GmbH's strategic project.",
    tags: ["Excel", "Data Analysis", "Environmental Strategy"],
    image: "https://images.unsplash.com/photo-1606836591695-4d58a73eba1e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMG1lZXRpbmd8ZW58MHx8fHwxNzYwMDI4NjI3fDA&ixlib=rb-4.1.0&q=85",
    period: "2024"
  },
  {
    id: 2,
    title: "Billing Process Optimization",
    category: "Operations Management",
    description: "Contributed to the implementation and optimization of internal billing processes at TSM Garage, streamlining operations and improving efficiency.",
    tags: ["Process Improvement", "Operations", "Software Implementation"],
    image: "https://images.unsplash.com/photo-1709715357520-5e1047a2b691?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMG1lZXRpbmd8ZW58MHx8fHwxNzYwMDI4NjI3fDA&ixlib=rb-4.1.0&q=85",
    period: "2025"
  },
  {
    id: 3,
    title: "Peace in All Languages",
    category: "Social Impact",
    description: "Winner of the 'Peace in All Languages' project at Lycée Français St-Exupéry, promoting intercultural dialogue and understanding.",
    tags: ["Leadership", "Intercultural Communication", "Social Impact"],
    image: "https://images.unsplash.com/photo-1616587656977-ac36a5a430bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMG1lZXRpbmd8ZW58MHx8fHwxNzYwMDI4NjI3fDA&ixlib=rb-4.1.0&q=85",
    period: "2023"
  },
  {
    id: 4,
    title: "Supply Chain Management System",
    category: "Logistics",
    description: "Managed comprehensive inventory tracking system for spare parts, equipment, and consumables, ensuring efficient supply chain operations.",
    tags: ["Supply Chain", "Inventory Management", "Excel"],
    image: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3NjAwMjg2MjJ8MA&ixlib=rb-4.1.0&q=85",
    period: "2025"
  }
];

export const interests = [
  "Basketball",
  "Fashion & Style",
  "Horseback Riding",
  "Online Strategy Games"
];
